import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { Check } from '@mui/icons-material';

const NoGpusModal = (props) => {
  return (
    <Dialog
      open={props.errorMessage === 'Not Enough Credits'}
      onClose={props.clearError}
    >
      <DialogTitle>Not Enough Credits</DialogTitle>
      <DialogContent>
        <Typography>
          Your account does not have enough credits to start this job. Please
          add credits to your account, reduce the number of GPU for this job, or
          select a lower cost GPU.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant='contained'
          startIcon={<Check />}
          onClick={props.clearError}
        >
          Okay
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NoGpusModal;
